import React from "react";
import "./MainTablePaginationAdv.css";

function MainTablePaginationAdv({
  pageSize,
  setPageSize,
  previousPage,
  canPreviousPage,
  pageIndex,
  pageOptions,
  nextPage,
  canNextPage,
  gotoPage,
  pageCount,
}) {
  return (
    <>
      <div className="table_footer-modal-pagination">
        <div className="Adv_Pagination_Button_div">
          <button
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            className="Adv_Pagination_Button"
            style={!canPreviousPage?{background:"gray"}:{background:"#3f6affb5"}}
          >
            {"<<"}
          </button>
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="Adv_Pagination_Button"
            style={!canPreviousPage?{background:"gray"}:{background:"#3f6affb5"}}
          >
            {"<"}
          </button>
          <span style={{ marginTop: "5px" }}>
            <strong>
              Page {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="Adv_Pagination_Button"
            style={!canNextPage?{background:"gray"}:{background:"#3f6affb5"}}
          >
            {">"}
          </button>
          <button
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
            className="Adv_Pagination_Button"
            style={!canNextPage?{background:"gray"}:{background:"#3f6affb5"}}
          >
            {">>"}
          </button>
        </div>
        <div className="goto_pagination_div">
         {/*  <span>
            <strong> Go to Page : </strong>
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "88px", textAlign:"center" }}
            />
          </span> */}
          <div style={{ marginTop: "0px" }}>
            <strong> Page Size : </strong>
            <select
              className="page_selector"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              style={{
                backgroundColor: "white",
                width: "60px",
                textAlign: "center",
                padding: "1px",
              }}
            >
              {[25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* </div> */}
      </div>
    </>
  );
}
export default MainTablePaginationAdv;
